import { Route, RouteObject } from "react-router-dom";
import { ixIntegrationRoutes } from "./integration/routes";
import { ixPaymentRoutes } from "./payment/routes";
import { ixErpIntegrationRoutes } from "./erpIntegration/routes";
import { ixGisIntegrationRoutes } from "./gisIntegration/routes";
import { ixSmartMeterOemRoutes } from "./smartMeterOem/routes";
import { ixIvrIntegrationRoutes } from "./ivrIntegration/routes";
import { ixGeneralIntegrationRoutes } from "./generalIntegration/routes";

export interface ixRoute extends Omit<RouteObject, "children"> {
  auth?: boolean;
  children?: ixRoute[];
}

export const ixRoutes: ixRoute[] = [
  ...ixIntegrationRoutes,
  ...ixPaymentRoutes,
  ...ixErpIntegrationRoutes,
  ...ixGisIntegrationRoutes,
  ...ixSmartMeterOemRoutes,
  ...ixIvrIntegrationRoutes,
  ...ixGeneralIntegrationRoutes,
];
